/* eslint-disable import/no-unresolved */
import React from 'react';
import {
  FormControl,
  Select as MuiSelect,
  MenuItem,
  InputLabel,
} from '@mui/material';

interface SelectProps {
  items: any[];
  label: string;
  name: string;
  selected: string;
  size: 'small' | 'medium' | undefined;
  handleSelected: (selected: string) => void;
}

// THIS IS NOT TO BE USED IN A FORM, AS THERE IS NO VALIDATION
const Select: React.FC<SelectProps> = ({
  name,
  label,
  items,
  selected,
  handleSelected,
  size,
}) => {
  const handleChange = (e: any) => {
    handleSelected(e.target.value);
  };

  return (
    <FormControl sx={{ width: '100%' }} size={size}>
      <InputLabel id="select-readonly-label">{label}</InputLabel>
      <MuiSelect
        name={name}
        value={selected}
        label={label}
        onChange={handleChange}
      >
        {items?.map((value: any) => (
          <MenuItem key={value.name} value={value.name}>
            {value.name}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  );
};

export default Select;
